import {useDispatch, useSelector} from "react-redux";
import {RegionSelectProps} from "../../Filters/RegionSelect";
import React from "react";
import {
    selectedRegionIdSelectorMonitoring,
    selectedRegionIdsSelectorMonitoring,
    setSelectedRegionMonitoring
} from "../Selectors/filtersSliceMonitoring";

export const useSelectedRegionMonitoring = () => {
    const dispatch = useDispatch();
    const regionId = useSelector(selectedRegionIdSelectorMonitoring);
    const regionIds = useSelector(selectedRegionIdsSelectorMonitoring);

    const onSelectRegion: NonNullable<RegionSelectProps['onSelect']> = React.useCallback((id, ids) => {
        dispatch(setSelectedRegionMonitoring({ id, ids }));
    }, [dispatch]);
    return {
        regionId,
        regionIds,
        onSelectRegion,
    };
};